export function getEndOfCurrentMonth() {
    /*Get end date string for trend calculation in the current month. End dates always have to be the last day of a month.*/
    const now = new Date();
    const now_end_of_month = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 0 -> last day of the month
    // return in format "YYYY-MM-DD" with padded month and day
    const year = now_end_of_month.getFullYear();
    const month = String(now_end_of_month.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
    const day = String(now_end_of_month.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function getEndOfLastMonth() {
    /*Get end date string for trend calculation in the last month. End dates always have to be the last day of a month.*/
    const now = new Date();
    const last_month_end = new Date(now.getFullYear(), now.getMonth(), 0); // 0 -> last day of the month
    // return in format "YYYY-MM-DD" with padded month and day
    const year = last_month_end.getFullYear();
    const month = String(last_month_end.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
    const day = String(last_month_end.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function getEndOfLastYear() {
    /*Get end date string for trend calculation in the current month. End dates always have to be the last day of a month.*/
    const now = new Date();
    const end_of_last_year = new Date(now.getFullYear()-1, 12, 31);
    // return in format "YYYY-MM-DD" with padded month and day
    const year = end_of_last_year.getFullYear();
    const month = String(end_of_last_year.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
    const day = String(end_of_last_year.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function getEndOfCurrentYear() {
    /*Get end date string for trend calculation in the current month. End dates always have to be the last day of a month.*/
    const now = new Date();
    const end_of_current_year = new Date(now.getFullYear(), 12, 0); // 0 -> last day of the month
    // return in format "YYYY-MM-DD" with padded month and day
    const year = end_of_current_year.getFullYear();
    const month = String(end_of_current_year.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
    const day = String(end_of_current_year.getDate()).padStart(2, '0');
}

export function get5YTrendStartDate() {
    /*Get start date string for trend calculation in the last 5 years. Start dates always have to be the first day of a month.*/
    const now = new Date();
    const start_date = new Date(now.getFullYear()-5, now.getMonth(), 1); // 1 -> first day of the month
    // return in format "YYYY-MM-DD" with padded month and day
    const year = start_date.getFullYear();
    const month = String(start_date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
    const day = String(start_date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}